module.exports = __webpack_public_path__ + "static/media/etherum.1d3583b0.png";